const loadYoutubeScript = () => {
  const tag = document.createElement('script');
  tag.src = 'https://www.youtube.com/iframe_api';
  tag.defer = true;

  document.body.appendChild(tag);
};

export default loadYoutubeScript;
